import React, { Component } from "react";
import "react-toastify/dist/ReactToastify.css";
import { SideBar, NavBar, Footer, TitleAndDescription } from "../../components";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import queryString from "query-string";
const { formatarReal } = require("../../utils");

export default class ProdutoDetalhe extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
    this.createMarkup = this.createMarkup.bind(this);
    this.alteraImagemPrincipal = this.alteraImagemPrincipal.bind(this);

    this.state = {
      produto: null,
      idProduto: queryString.parse(this.props.location.search).id,
      exibirIformacaoItemPedido: false,
    };
  }

  componentDidMount() {
    let tipoDetalhe = queryString.parse(this.props.location.search).tipo;

    if (!tipoDetalhe === "produtoDestaque" || tipoDetalhe === undefined) {
      this.setState({ exibirIformacaoItemPedido: true });
    }
    this.load();
  }

  async load() {
    let produto = { idProduto: this.state.idProduto };
    let produtoBusca = [];
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/produtosDetalhe`,
        produto,
        this.props.parameters()
      )
      .then((response) => {
        produtoBusca = response.data;
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
        }
      });
    let imagens = [];
    await axios
      .post(
        `${this.props.getBaseUrlApi()}/produtosImagemMedium`,
        produto,
        this.props.parameters()
      )
      .then((response) => {
        imagens = response.data;
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
        }
      });

    if (imagens.length) {
      produtoBusca.imagemPrincipal = imagens[0];
    }

    this.setState({
      produto: produtoBusca,
      imagensMedium: imagens
    });
  }

  createMarkup(html) {
    return { __html: html };
  }

  alteraImagemPrincipal(seq) {
    let produto = this.state.produto;
    let imagens = this.state.imagensMedium;
    produto.imagemPrincipal = imagens[seq];
    this.setState({ produto });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Detalhe do Produto" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"produtoDestaque"} />
            <div className="main-panel">
              <div className="content-wrapper">
                <React.Fragment>
                  <NavBar
                    title="Detalhe do item"
                    history={this.props.history}
                  />

                  {this.state.produto !== null && (
                    <div className="container-detalhe-produto">
                      <div className="container card">
                        <div className="float-left width-100 d-flex">
                          <div className="col-6">
                          </div>

                          <div
                            className="col-6"
                            style={{ position: "relative", paddingTop: "10px" }}
                          >
                            {this.state.produto.isNovo && (
                              <div className="label-produto-detalhe-novo">
                                NOVO
                              </div>
                            )}

                            {!this.state.produto.isNovo &&
                              this.state.produto.precoDetalhe
                                .precoPromocional !== null && (
                                <div className="label-produto-detalhe-promo">
                                  PROMO
                                </div>
                              )}
                          </div>
                        </div>
                        <div
                          className="titulo-produto"
                          style={{ color: "#5f9f1a", fontWeight: "bold" }}
                        >
                          #{this.state.produto.cod} - {this.state.produto.desc}
                        </div>

                        <div style={{ paddingTop: "10px" }}>
                          <div className="font-size-14">
                            Preço Padrão : R${" "}
                            {formatarReal(
                              this.state.produto.preco.precoUnitComImpostos
                            )}
                          </div>
                          <div className="font-size-14">
                            Estoque:{" "}
                            <span
                              style={{
                                color:
                                  this.state.produto.estoque.qtd === 0
                                    ? "red"
                                    : "inherit",
                                fontWeight:
                                  this.state.produto.estoque.qtd === 0
                                    ? "bold"
                                    : "normal",
                              }}
                            >
                              {this.state.produto.estoque.qtd}{" "}
                              {this.state.produto.unid}
                            </span>
                          </div>
                          <div className="font-size-14">
                            Embalagem: {this.state.produto.preco.embPadrao}
                          </div>
                        </div>

                        <div
                          className="d-flex w-100"
                          style={{ padding: "20px 0" }}
                        >
                          <div
                            className="imagem-principal col-6"
                            style={{ border: "1px solid #c8c8c8" }}
                          >
                            <img
                              className="img-responsive"
                              //src={this.state.produto.imagemPrincipal}
                              src={this.state.produto.imagemPrincipal}
                              alt="celular"
                              style={{ width: "40%", marginLeft: "-9px" }}
                            />
                          </div>

                          <div
                            className=""
                            style={{
                              fontSize: "13px",
                              justifyContent: "center",
                            }}
                          >
                            {this.state.produto.imagens.map((image, key) => (
                              <div
                                className="col-3 float-left"
                                style={{
                                  padding: "0 5px",
                                  textAlign: "center",
                                }}
                                key={key}
                              >
                                <div
                                  className="imagem-principal2 float-left width-100"
                                  style={{ cursor: "pointer" }}
                                  onClick={(e) =>
                                    {
                                      //this.alteraImagemPrincipal(key)
                                    }
                                  }
                                >
                                  <img
                                    className="img-responsive float-left width-100"
                                    src={image}
                                    alt="celular"
                                    style={{ width: "100%" }}
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div
                          className="d-flex float-left width-100"
                          style={{
                            fontSize: "13.5px",
                            //borderBottom: "1px solid #d9d9d9",
                          }}
                        ></div>

                        <div
                          className="float-left width-100"
                          style={{ fontSize: "14px", padding: "5px 0" }}
                        >
                          Descrição Técnica:
                        </div>

                        <div
                          className="float-left width-100"
                          style={{
                            fontSize: "13px",
                            padding: "20px 0",
                            //marginLeft: "7px",
                          }}
                          dangerouslySetInnerHTML={this.createMarkup(
                            this.state.produto.descTecnica
                          )}
                        ></div>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
